import { useMutation } from '@tanstack/react-query'
import useSupabase from './use-supabase'
import configuration from '~/configuration'

interface Credentials {
  email: string
  password: string
}

/**
 * @name useSignUpWithEmailAndPassword
 */
function useSignUpWithEmailAndPassword() {
  const client = useSupabase()

  const mutationFn = async (credentials: Credentials) => {
    const emailRedirectTo = getRedirectUrl()

    const response = await client.auth.signUp({
      ...credentials,
      options: {
        emailRedirectTo,
      },
    })

    if (response.error) {
      throw response.error
    }

    const user = response.data?.user
    const identities = user?.identities ?? []

    // if the user has no identities, it means that the email is taken
    if (identities.length === 0) {
      throw new Error('User already registered')
    }

    return response.data
  }

  return useMutation({
    mutationFn,
  })
}

export default useSignUpWithEmailAndPassword

function getRedirectUrl() {
  const nextPath = configuration.paths.onboarding
  const callbackPath = `/auth/callback`

  const searchParams = new URLSearchParams({
    next: nextPath,
  })

  const fullPath = [callbackPath, searchParams.toString()].join('?')

  return [window.location.origin, fullPath].join('')
}
